import React from 'react';
import styled from 'styled-components'

import { Table, CSVButton, PDFButton } from '../common';
import { Box } from 'vqp-common'
import { CardTitle } from './'

import emptyAvatarImg from '../../assets/avatar.png';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`

const Card = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
`


const ActionsContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-self: flex-end;
    justify-content: space-between;
    margin-top: 20px;
    width: 300px;
`

const makeCSVHeaders = (columns) => (
    columns.map(col => ({
        label: col.Header,
        key: col.accessor
    }))
)

export const ClientsRanking = ({clients}) => {
     
      const columns = [
        {
            Header: '#',
            accessor: 'ranking',
            maxWidth: 40
        },
        {
            Header: 'Cliente',
            accessor: 'name',
            Cell: props => (
                <div>
                    <img src={props.row.image || emptyAvatarImg} alt={props.value} />&nbsp;
                    <span>{props.value}</span>
                </div>
            )
        },
        {
            Header: 'Período',
            accessor: 'period',
            maxWidth: 70
        },
        {
            Header: 'Sempre',
            accessor: 'always',
            maxWidth: 70,
        }
    ]
    
    return (
        <Wrapper>
            <CardTitle>Ranking de Clientes</CardTitle>
            <Card>
                <Table
                    className="-striped"
                    data={clients}
                    columns={columns}
                    minRows={20}
                    getTrProps={() => ({
                        style: {
                            height: '50px',
                        }
                    })}
                    getTdProps={() => ({
                        style: {
                            alignSelf: 'center'
                        }
                    })}
                />
            </Card>
            <ActionsContainer>
                <CSVButton 
                    headers={makeCSVHeaders(columns)} 
                    data={clients}
                    title="RankingClientes" />
                <PDFButton 
                    headers={makeCSVHeaders(columns)} 
                    data={clients}
                    title="RankingClientes" />
            </ActionsContainer>
        </Wrapper>
    )
}

